var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeepCleanIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 120,
    viewBox: "0 0 106 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 103.774C2 109.902 7.83648 113.623 10.7547 114.717C14.5 115.5 18.5 116 22.7925 114.717C32.6415 114.717 32.6415 100.491 32.6415 95.0189C37.8943 92.3925 37.7484 85.17 37.0189 81.887C35.9245 77.5097 30.8906 69.1927 19.5094 70.9436C8.1283 72.6946 8.20126 84.0757 9.66038 89.5474C7.10692 91.7361 2 97.6455 2 103.774Z",
    stroke: "#007EBD",
    strokeWidth: 2.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4527 72.9478C38.7776 73.6138 42.6423 80.3059 43.5848 84.0759C44.3144 87.3589 44.4603 94.5813 39.2075 97.2078C39.2075 102.679 39.2075 116.906 29.3584 116.906C27.2389 117.604 21.7 118.3 16.5 115.5",
    stroke: "#007EBD",
    strokeWidth: 2.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5093 104.868L81.8866 70.9434",
    stroke: "#007EBD",
    strokeWidth: 2.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0376 60L15.1319 66.566",
    stroke: "#007EBD",
    strokeWidth: 2.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2075 118H80.7924C82.9811 117.27 87.5773 114.498 88.4528 109.245C89.3283 103.992 93.9245 74.2264 96.1132 60",
    stroke: "#007EBD",
    strokeWidth: 2.2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M41.396 31.0001C43.1521 24.3921 49.3457 19.5095 56.7168 19.5095C64.0878 19.5095 70.2814 24.3921 72.0375 31.0001M44.8524 44.9643C47.751 48.145 51.992 50.151 56.7168 50.151C61.4415 50.151 65.6825 48.145 68.5811 44.9643",
    stroke: "#007EBD",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7398 29.7738C40.1773 28.8145 38.3556 28.2642 36.4105 28.2642C31.2593 28.2642 26.9737 32.124 26.0752 37.2178M28.7679 48.9073C30.6839 51.0207 33.3993 52.3396 36.4105 52.3396C40.4943 52.3396 44.0339 49.9139 45.7733 46.3705",
    stroke: "#007EBD",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3444 38.3041C25.1997 37.4922 23.824 37.0188 22.3442 37.0188C18.3609 37.0188 15.1318 40.4485 15.1318 44.6792C15.1318 48.9099 18.3609 52.3396 22.3442 52.3396C24.7952 52.3396 26.9606 51.041 28.2639 49.0563",
    stroke: "#007EBD",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M72.7876 30.3693C74.1573 29.5283 75.7542 29.0459 77.4594 29.0459C81.9751 29.0459 85.7319 32.4295 86.5195 36.8949M84.159 47.1421C82.4795 48.9947 80.0991 50.1509 77.4594 50.1509C73.8795 50.1509 70.7765 48.0245 69.2518 44.9183",
    stroke: "#007EBD",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M86.2836 37.8469C87.2871 37.1352 88.4931 36.7202 89.7903 36.7202C93.2821 36.7202 96.1128 39.7267 96.1128 43.4355C96.1128 47.1442 93.2821 50.1507 89.7903 50.1507C87.6417 50.1507 85.7434 49.0123 84.601 47.2725",
    stroke: "#007EBD",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M96.1132 43.5849C96.1132 20.6182 77.495 2 54.5283 2C31.5616 2 12.9434 20.6182 12.9434 43.5849",
    stroke: "#007EBD",
    strokeWidth: 2.2
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0378 43.585H11.3774C8.61602 43.585 6.37744 45.8235 6.37744 48.585V53.9057C6.37744 56.6671 8.61602 58.9057 11.3774 58.9057H99.868C102.629 58.9057 104.868 56.6671 104.868 53.9057V48.585C104.868 45.8235 102.629 43.585 99.868 43.585H96.1133",
    stroke: "#007EBD",
    strokeWidth: 2.2,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeepCleanIcon);
export default __webpack_public_path__ + "static/media/deepCleanIcon.8c90c95b2a8e48be1ec66934595d3b35.svg";
export { ForwardRef as ReactComponent };